import React, { useEffect, useState } from 'react';
import API from '../services/api';
import Sidebar      from '../components/AnalyticsSidebar';
import DataTable    from '../components/DataTable';
import './_analytics.css';

export default function GuestsTable() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    (async () => {
      const hdr = { headers:{ Authorization:`Bearer ${localStorage.token}` } };
      const { data } = await API.get('/guests', hdr);
      setRows(data || []);
    })();
  }, []);

  const columns = [
    { header:'Date & Time', cell:g => new Date(g.createdAt).toLocaleString() },
    { header:'Name',        cell:g => g.name },
    { header:'CNIC',        cell:g => g.cnic },
    { header:'Office',      cell:g => g.visitingOffice },
    { header:'Vehicle',     cell:g => g.vehicleNo },
    { header:'Status',      cell:g =>
        <span className={`status-badge status-${g.status}`}>{g.status}</span> },
  ];

  return (
    <div className="split-layout">
      <Sidebar />

      <div className="table-wrapper">
        <h2>🧑‍💼 Guests – All Visits</h2>

        <DataTable
          columns={columns}
          rows={rows}
          searchKeys={['name','cnic','visitingOffice','vehicleNo']}
          dateKey="createdAt"
        />
      </div>
    </div>
  );
}
